import { ColumnDef } from '@tanstack/react-table'
import { AssetOverviewDataContext } from 'features/assetDatabase/contexts/AssetOverviewDataLayer'
import React, { useContext } from 'react'
import { GeckoReport } from 'types'

import { FilesTable, FilesTableEntry } from './FilesTable'

interface AssetFilesTableProps {
  unitID: string
  reports: readonly GeckoReport[]
  isLoading: boolean
  hasEverLoaded: boolean
  forceRefresh: () => void
  customColumns?: ColumnDef<FilesTableEntry>[]
  showColumnConfig?: boolean
  showFilterBar?: boolean
}

export const AssetFilesTable: React.FC<AssetFilesTableProps> = (props) => {
  const {
    components,
    unit,
    refreshData,
    refreshThumbnails,
    setIsPrimaryImageLoaded,
  } = useContext(AssetOverviewDataContext)

  return (
    <FilesTable
      {...props}
      components={components}
      unit={unit}
      refreshData={refreshData}
      refreshThumbnails={refreshThumbnails}
      setIsPrimaryImageLoaded={setIsPrimaryImageLoaded}
    />
  )
}
